import getLocation from '@atlassian/jira-common-location/src/index.tsx';

export const useDestinationParam = (): string => {
	const { href = null } = getLocation() || {};
	if (href && !href.includes('login.jsp')) {
		const encodedRedirectUrl = encodeURIComponent(href);
		return `os_destination=${encodedRedirectUrl}`;
	}
	return '';
};
